export default __webpack_public_path__ + "static/media/DesktopImageItem2.5164fc66.png";